/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerPromptQueryResponse, IncidentInvestigationControllerPromptPathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerPrompt";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { incidentInvestigationControllerPrompt } from "../../clients/incident-agentService/incidentInvestigationControllerPrompt";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const incidentInvestigationControllerPromptQueryKey = (id: IncidentInvestigationControllerPromptPathParams["id"]) => [{
  url: '/api/v1/incident-agent/investigations/:id/prompt',
  params: {
    id: id
  }
}] as const;
export type IncidentInvestigationControllerPromptQueryKey = ReturnType<typeof incidentInvestigationControllerPromptQueryKey>;
export function incidentInvestigationControllerPromptQueryOptions(id: IncidentInvestigationControllerPromptPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = incidentInvestigationControllerPromptQueryKey(id);
  return queryOptions<IncidentInvestigationControllerPromptQueryResponse, ResponseErrorConfig<Error>, IncidentInvestigationControllerPromptQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return incidentInvestigationControllerPrompt(id, config);
    }
  });
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/prompt}
 */
export function useIncidentInvestigationControllerPrompt<TData = IncidentInvestigationControllerPromptQueryResponse, TQueryData = IncidentInvestigationControllerPromptQueryResponse, TQueryKey extends QueryKey = IncidentInvestigationControllerPromptQueryKey>(id: IncidentInvestigationControllerPromptPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<IncidentInvestigationControllerPromptQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? incidentInvestigationControllerPromptQueryKey(id);
  const query = useQuery({
    ...incidentInvestigationControllerPromptQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}